// extracted by mini-css-extract-plugin
export var areasList = "lists-module--areasList--05941";
export var flipCardBack = "lists-module--flipCardBack--188fb";
export var flipCardBox = "lists-module--flipCardBox--a927e";
export var flipCardFront = "lists-module--flipCardFront--3687a";
export var flipCards = "lists-module--flipCards--d8d4c";
export var list2 = "lists-module--list2--ead1e";
export var list3 = "lists-module--list3--c6117";
export var listServices = "lists-module--listServices--654d7";
export var listStrong = "lists-module--listStrong--631b7";